import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import LegalPageLayout from './LegalPageLayout';

export default function CookiePolicy() {
  const { analytics, decided, acceptAll, rejectAll, updateConsent } = useCookieConsent();
  const analyticsAccepted = analytics === true;

  return (
    <LegalPageLayout title="Cookie Policy" testId="rwm-cookie-policy">
      <section data-testid="rwm-cookies-manage-prefs">
        <h2>Manage Your Cookie Preferences</h2>
        <p>
          Analytics cookies:{' '}
          <strong>{analyticsAccepted ? 'Accepted' : 'Not accepted'}</strong>
        </p>
        <div className="d-flex flex-wrap gap-2 mb-2">
          {!analyticsAccepted ? (
            <Button
              type="button"
              variant="info"
              className="text-white"
              onClick={() => acceptAll()}
              data-testid="rwm-cookies-accept-analytics"
            >
              Accept Analytics
            </Button>
          ) : null}
          {analyticsAccepted ? (
            <>
              <Button
                type="button"
                variant="outline-secondary"
                onClick={() => updateConsent({ analytics: false })}
                data-testid="rwm-cookies-withdraw"
              >
                Withdraw Consent
              </Button>
              <Button
                type="button"
                variant="outline-secondary"
                onClick={() => rejectAll()}
                data-testid="rwm-cookies-essential-only"
              >
                Essential Only
              </Button>
            </>
          ) : null}
        </div>
        {!decided ? (
          <p className="text-muted small">
            You have not set a cookie preference yet. Use the buttons above to choose how we use
            analytics cookies.
          </p>
        ) : null}
      </section>

      <h2>What Are Cookies</h2>
      <p>
        Cookies are small text files stored on your device when you visit a website. They help
        websites remember your preferences and keep you signed in. Some cookies are essential for
        the platform to function; others require your consent.
      </p>

      <h2>Cookies We Use</h2>
      <div className="table-responsive">
        <Table bordered className="rwm-legal__table mb-0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Purpose</th>
              <th>Type</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Session cookie</td>
              <td>Authentication state</td>
              <td>Essential</td>
              <td>Session</td>
            </tr>
            <tr>
              <td>rwm_token</td>
              <td>Bearer auth token (sessionStorage, not a cookie)</td>
              <td>Essential</td>
              <td>Session</td>
            </tr>
            <tr>
              <td>rwm_cookie_consent</td>
              <td>Cookie consent record (localStorage)</td>
              <td>Essential</td>
              <td>Until cleared</td>
            </tr>
            <tr>
              <td>_ga, _gid</td>
              <td>Google Analytics</td>
              <td>Analytics (opt-in)</td>
              <td>2 years / 1 day</td>
            </tr>
          </tbody>
        </Table>
      </div>

      <h2>Cookie Consent</h2>
      <ul>
        <li>Essential cookies cannot be disabled — they are required for the platform to work.</li>
        <li>Analytics cookies are only set after you give explicit consent.</li>
      </ul>

      <h2>Managing Cookies</h2>
      <p>
        You can control and delete cookies through your browser settings. Most browsers allow you
        to block third-party cookies, clear stored cookies, or receive a warning before a cookie is
        stored. Note that disabling essential cookies may prevent you from using parts of the
        platform.
      </p>

      <h2>Contact</h2>
      <p className="mb-0">
        For questions about cookies, contact{' '}
        <a href="mailto:privacy@remoteworkmarket.com">privacy@remoteworkmarket.com</a>.
      </p>
    </LegalPageLayout>
  );
}
